import React from 'react';

import { SVGComponentProps } from './svg.types';

const SingleChoiceSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherSvgProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <g clipPath="url(#clip0_6790_35245)">
        <rect width={size} height={size} rx="2" fill="white" />
        <circle cx="7.5" cy="11.5" r="3" fill="white" stroke="#55585E" />
        <rect x="12" y="8" width="8" height="1" fill={fill} />
        <rect x="12" y="11" width="8" height="1" fill={fill} />
        <rect x="12" y="14" width="8" height="1" fill={fill} />
      </g>
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      <defs>
        <clipPath id="clip0_6790_35245">
          <rect width={size} height={size} rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SingleChoiceSVG;
